import React from 'react';
import { apiAction } from '../../../store/generalSlice';
import { useDispatch } from 'react-redux';

const Creative = (props) => {
  const dispatch = useDispatch();
  const { action, fieldName, field, state, setState } = props;

  return field && state && setState ? (
    <div key={field.id} className='col-md-6 p-3 border'>
      <label>
        <b>{field.id}: </b>
        {field.description}
      </label>
      {state[field.id]?.isUseSource ? <h5>Using Source Data</h5> : <h5>Manage in Creative Section Bellow</h5>}
      <div className='form-check mt-2'>
        <input
          type='checkbox'
          className='form-check-input'
          checked={state[field.id] ? state[field.id].isUseSource : null}
          onChange={(e) => {
            setState((prevState) => {
              return {
                ...prevState,
                [field.id]: { ...prevState[field.id], isUseSource: e.target.checked },
              };
            });
            dispatch(
              apiAction({
                reduxField: 'action',
                route: `actions/updateDuplicateAction`,
                actionId: action._id,
                fieldName,
                changes: { ...state, [field.id]: { ...state[field.id], isUseSource: e.target.checked } },
              })
            );
          }}
        />
        <label className='form-check-label'>Use Source</label>
      </div>
    </div>
  ) : null;
};

export default Creative;
